<template>
  <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
    <md-card class="">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>event_busy</md-icon>
        </div>
        <h4 class="title">{{ data.label }}</h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 md-layout-data">
            <md-table class="">
              <md-table-row
                v-for="(row, rowIndex) in data.data"
                :key="rowIndex"
              >
                <md-table-cell>{{ row.label }}</md-table-cell>
                <md-table-cell
                  >{{ formatDate(row["start_date"]) }} t/m
                  {{ formatDate(row["stop_date"]) }}</md-table-cell
                >
              </md-table-row>
              <md-table-row v-if="data.data.length === 0">
                <md-table-cell
                  >Deze widget heeft geen data om weer te geven.</md-table-cell
                >
              </md-table-row>
            </md-table>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["data"],
  methods: {
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("‑");
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-layout-data {
  max-height: 200px;
  overflow-y: auto;
}
</style>
